import {Icon} from '@wandb/weave/components/Icon';
import React, {type FC, type MouseEvent} from 'react';
import {useHistory} from 'react-router-dom';

const NavLeftInIframe: FC = () => {
  const history = useHistory();
  return (
    <>
      <h1>Weights &amp; Biases</h1>
      <Icon
        className="nav"
        title="Go backward"
        onClick={(e: MouseEvent) => {
          e.preventDefault();
          history.goBack();
        }}
        name="chevron-back"
      />
      <Icon
        className="nav"
        title="Go forward"
        onClick={(e: MouseEvent) => {
          e.preventDefault();
          history.goForward();
        }}
        name="chevron-next"
      />
    </>
  );
};

export default NavLeftInIframe;
